import axios from 'axios';
import React, { useEffect } from 'react';
import { genURL } from '../../_getjson';
import PropTypes from 'prop-types';
import { Box, color } from '@mui/system';
import DataTable from './components/table';
import { Button } from '@mui/material';
import Repostview from './Repostview';
import FullScreenDialog from '../CustomDialogs/Fullscreendialog';
import CustomSnackbar from '../Snackbar/Snackbar';


function PDFReportDialog(props) {
    const { docNo, mid } = props
    const [state, setState] = React.useState({
        reportURL: "",
        formPrintData: [],
        loading: false,
        selectedRows: [],
        data: [],
        openDialog: false,
        titleDialog: "",
        color: "info",
        icon: "info",
        autoClose: 5000,
        messageAlert: "",
        openSnackbar: false,
    })
    useEffect(() => {
        if (mid !== undefined || mid !== "" && docNo !== undefined || docNo !== "") {
            loadReportData(docNo, mid)
        }
    }, [mid])

    // useEffect(() => {
    //     loadReportData(props.mid)
    // }, [docNo])


    // Define columns
    const columns = [
        {
            field: 'nameTH',
            headerName: 'ชื่อ/คำอธิบาย',
            width: 500
        },
        {
            field: 'categoryreportnameTH',
            headerName: 'ประเภท',
            minWidth: 100
        },
        {
            field: 'actions',
            headerName: 'การจัดการ',
            width: 150,
            align: 'center',
            renderCell: (value, row) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleViewReport(row);
                    }}
                >
                    ดูรายงาน
                </Button>
            )
        }
    ];
    const loadReportData = async (docNo, mid) => {
        setState(pevState => ({
            ...pevState,
            loading: true

        }))
        try {
            let url = `reportmanage/reportform/${mid}?`
            let res = await axios.get(genURL(url))
            console.log('Report data loaded url :', genURL(url));
            console.log('Report data loaded:', res.data);
            if (res.data.length > 1) {
                setState(pevState => ({
                    ...pevState,
                    //  reportURL: res.data[0].pathname,
                    data: res.data
                }))
            } else if (res.data.length > 0) {
                if (docNo === undefined || docNo === "") {
                    setState(pevState => ({
                        ...pevState,
                        openSnackbar: true,
                        color: "error",
                        icon: "error",
                        messageAlert: "กรุณาระบุเลขที่เอกสารด้วยครับ",
                    }))
                    return
                }
                await setState(pevState => ({
                    ...pevState,
                    titleDialog: res.data[0].nameTH,
                    reportURL: `${process.env.REACT_APP_REPORTURL}${res.data[0].pathname}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docNo}`,
                    openDialog: true
                }))
            } else {
                setState(pevState => ({
                    ...pevState,
                    openSnackbar: true,
                    color: "error",
                    icon: "error",
                    messageAlert: "ไม่พบข้อมูลรายงาน",
                }))
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setState(pevState => ({
                ...pevState,
                loading: false

            }))
        }
    }

    const handleViewReport = (report) => {
        console.log('View report:', report);
        console.log('View report:', report.pathname);

        if (docNo === undefined || docNo === "") {
            setState(pevState => ({
                ...pevState,
                openSnackbar: true,
                color: "error",
                icon: "error",
                messageAlert: "กรุณาระบุเลขที่เอกสารด้วยครับ",
            }))
            return
        }

        setState(pevState => ({
            ...pevState,
            openDialog: true,
            titleDialog: report.nameTH,
            reportURL: `${process.env.REACT_APP_REPORTURL}${report.pathname}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docNo}`
        }))

        // this.setState({
        //     openFullScreenDialog: true,
        //     typeFullScreenDialog: "Report",
        //     titleFullScreenDialog: "พิมพ์ใบบันทึกสั่งขาย",
        //     urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`
        // });
        // setState(pevState => ({
        //     ...pevState,
        // reportURL: report.pathname
        // frmPrintData: report
        // })) 
        // Implement your view report logic
    };

    const handleRowClick = (row) => {
        //    console.log('Row clicked:', row);
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>

                {state.selectedRows.length > 0 && (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            console.log('Delete selected:', state.selectedRows);
                            // Implement delete logic
                        }}
                    >
                        ลบรายการที่เลือก ({state.selectedRows.length})
                    </Button>
                )}
            </Box> */}

            <DataTable
                columns={columns}
                data={state.data}
                loading={state.loading}
                onRowClick={handleRowClick}
                selectable={true}
                selectedRows={state.selectedRows}
                onSelectionChange={state.setSelectedRows}
                idField="docNo"
                onRefresh={loadReportData}
                title="รายการรายงานทั้งหมด"
            />

            <FullScreenDialog open={state.openDialog} title={state.titleDialog}
                CloseDialog={async () => {
                    await setState(pevState => ({ ...pevState, openDialog: false }))
                    await props.closePopup(false)
                }}>
                <Repostview url={state.reportURL} />
            </FullScreenDialog>


            <CustomSnackbar place="br"
                color={state.color}
                icon={state.icon}
                autoClose={state.autoClose}
                message={state.messageAlert}
                open={state.openSnackbar}
                closeNotification={() => {
                    setState(prevState => ({
                        ...prevState,
                        openSnackbar: false
                    }))
                }}
                close />
        </Box>
    )
}

PDFReportDialog.prototype = {
    docNo: PropTypes.string,
    mid: PropTypes.string,
}


export default PDFReportDialog;